export default "__VITE_PUBLIC_ASSET__bc15a2de__"